module.exports = __webpack_public_path__ + "img/miranda-auto-eletrica-sinop.e9dd1c61.png";